<template>
    <div class="cmp-call-history">
        <template v-if="context.isAuthenticated">
            <div class="td-radio background my-2 ml-1" v-if="context.isInRole(constants.Roles.FleetUserRole)">
                <label for="search-history-user">
                    <input type="radio" v-model="type" id="search-history-user" @change="changeType" value="user" />
                    <span>My History</span>
                </label>

                <label for="search-history-account">
                    <input type="radio" v-model="type" id="search-history-account" @change="changeType" value="account" />
                    <span>Fleet History</span>
                </label>
            </div>

            <div class="upgrade-link td-text-center" v-if="!context.isInRole(constants.Roles.FleetUserRole)">
                <a class="td-btn secondary" href="/accounts/fleet-upgrade" title="Upgrade your account to view all of your search history."><span>Upgrade your account</span> to view all of your search history</a>
            </div>

            <div class="pa-1" v-if="!loading && list.length == 0"><span class="td-banner warning no-icon slim">You do not have any call history to display</span></div>
            <div v-else>
                <div class="pagination td-card border" v-if="context.isInRole(constants.Roles.FleetUserRole)">
                    <div class="td-text-subdued td-text-italic td-text-mice">
                        {{ pagerText }}
                    </div>
                    <div class="td-pagination-btns my-1 slim">
                        <button :disabled="!enablePrevious" :class="['secondary', 'previous', {'disabled': !enablePrevious}]"
                                @click.prevent="onPrevious"
                                title="Previous Page">
                            <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                            <icon v-if="!loading" type="solid" name="faAngleLeft" aria-hidden="true"></icon>
                        </button>
                        <button :class="['next', 'secondary', {'disabled': !enableNext}]"
                                @click.prevent="onNext"
                                title="Next"
                                :disabled="!enableNext">
                            <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                            <icon v-if="!loading" type="solid" name="faAngleRight" aria-hidden="true"></icon>
                        </button>
                    </div>
                </div>
                <div class="td-card border" v-else>
                    <div class="td-text-subdued td-text-mice">
                        <i>Only displaying last 5 calls.</i>
                    </div>
                </div>
                <ul class="history-list">
                    <li v-for="item in list" :key="item.model.id" class="history-item">
                        <div class="transaction-details">
                            <p>
                                <fa-icon :icon="['fas', 'location-dot']" aria-hidden="true"></fa-icon>
                                <strong>{{ item.listing.name }}</strong>
                            </p>
                            <span v-for="message in item.messages" class="td-text-subdued td-text-mice">{{ message }}.&nbsp;</span>
                        </div>
                        <div class="location-details">
                            <hours-status :listing="item.listing"></hours-status>
                            {{ item.listing.location.line1 }}<br />
                            {{ item.listing.location.line2 }}
                        </div>
                        <div class="contact-details">
                            <div class="labels">
                                <div v-for="phn in item.listing.phoneNumbers">
                                    <span>{{ phn.label }}:</span>
                                </div>
                            </div>
                            <div class="numbers">
                                <div v-for="phn in item.listing.phoneNumbers">
                                    <span>{{ phn.display }}</span>
                                </div>
                            </div>
                        </div>
                        <div class="actions">
                            <button class="td-btn primary icon-left slim" @click="viewListing(item.model)">
                                <icon type="solid" name="faSearch" aria-hidden="true"></icon>View Listing
                            </button>
                        </div>
                    </li>
                </ul>
                <div class="pagination td-card border" v-if="context.isInRole(constants.Roles.FleetUserRole)">
                    <div class="td-text-subdued td-text-italic td-text-mice">
                        {{ pagerText }}
                    </div>
                    <div class="td-pagination-btns my-1 slim">
                        <button :disabled="!enablePrevious" :class="['secondary', 'previous', {'disabled': !enablePrevious}]"
                                @click.prevent="onPrevious"
                                title="Previous Page">
                            <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                            <icon v-if="!loading" type="solid" name="faAngleLeft" aria-hidden="true"></icon>
                        </button>
                        <button :class="['next', 'secondary', {'disabled': !enableNext}]"
                                @click.prevent="onNext"
                                title="Next"
                                :disabled="!enableNext">
                            <icon v-if="loading" type="solid" name="faSpinner" spin aria-hidden="true"></icon>
                            <icon v-if="!loading" type="solid" name="faAngleRight" aria-hidden="true"></icon>
                        </button>
                    </div>
                </div>
                <div class="td-card border" v-else>
                    <div class="td-text-subdued td-text-mice">
                        <i>Only displaying last 5 calls.</i>
                    </div>
                </div>
            </div>
        </template>
        <signin-or-upgrade v-else>
            <template #heading>
                <h2>Call History</h2>
                <p>Automatically track the vendors you call.</p>
            </template>
            <template #subheading>
                <h3>This is a free feature available to logged-in accounts</h3>
                <h4>Create a <strong>free account</strong> or <strong>login</strong> to access vendors you have called!</h4>
            </template>
        </signin-or-upgrade>
    </div>
</template>

<script>import script from './CallHistory';
    export default script;</script>
<style lang="less">
    @import "./CallHistory.less";
</style>
